module.exports = __webpack_public_path__ + "static/img/bf.7194e240.svg";